module.exports = __webpack_public_path__ + "static/decoration-chrome-d68afe6af49a78c685a51abca6204f76.png";